import { render, staticRenderFns } from "./NewRace.vue?vue&type=template&id=3a78063f&scoped=true&"
import script from "./NewRace.vue?vue&type=script&lang=js&"
export * from "./NewRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a78063f",
  null
  
)

export default component.exports